import { useMediaQuery, useTheme } from '@mui/material';
import {
  type ComponentProps,
  createContext,
  type FC,
  type PropsWithChildren,
  useMemo,
} from 'react';

type State = {
  isMobileView: boolean;
};

export const MobileViewContext = createContext<State>({
  isMobileView: false,
});
MobileViewContext.displayName = 'MobileViewContext';

export const MobileViewProvider: FC<PropsWithChildren> = ({ children }) => {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));

  const state = useMemo(
    (): ComponentProps<typeof MobileViewContext.Provider>['value'] => ({
      isMobileView,
    }),
    [isMobileView],
  );

  return (
    <MobileViewContext.Provider value={state}>
      {children}
    </MobileViewContext.Provider>
  );
};
